import { IApplicationState } from '../../types/redux';

export const selectCurrentPromoId = (state: IApplicationState) => {
  return state.promoDetails.currentPromoId;
};
